import { get, map } from "lodash";
import moment from "moment";

export const getAvatar = icon => {
  switch (icon) {
    case "booking":
      return {
        icon: require("@/assets/svg/booking_list_icon.svg"),
        style: { "background-color": "#e3f2ff !important" }
      };
    case "offer":
      return {
        icon: require("@/assets/svg/offer_icon.svg"),
        style: { "background-color": "#d9f8ff !important" }
      };
    case "conversation":
      return {
        icon: require("@/assets/svg/conversation_icon.svg"),
        style: { "background-color": "#fff1cc !important" }
      };
    case "interview":
      return {
        icon: require("@/assets/svg/interview_icon.svg"),
        style: { "background-color": "#edeff0 !important" }
      };
    case "application":
      return {
        icon: require("@/assets/svg/application_black_icon.svg"),
        style: { "background-color": "#f2f2f2 !important" }
      };
    default:
      return {
        icon: require("@/assets/svg/booking_list_icon.svg"),
        style: { "background-color": "#f2f2f2 !important" }
      };
  }
};
export const getGroupedTodos = todos => {
  const grouped = todos.reduce((grouped, todo) => {
    const day = moment(todo.created_at).format("DD/MM/YYYY");
    const formattedTodoItem = {
      createdAt: todo.created_at,
      actionDetails: todo.action_details,
      todoableType: todo.todoable_type,
      todoableId: todo.todoable_id,
      ...todo
    };

    if (grouped[day]) {
      grouped[day][formattedTodoItem.category]
        ? grouped[day][formattedTodoItem.category].push(formattedTodoItem)
        : (grouped[day] = {
            ...grouped[day],
            [formattedTodoItem.category]: [formattedTodoItem]
          });

      return grouped;
    }
    return {
      ...grouped,
      [day]: { [formattedTodoItem.category]: [formattedTodoItem] }
    };
  }, {});

  return grouped;
};

export const getFormattedTodos = todos =>
  map(todos, todo => {
    const createdAt = todo.created_at;
    const actionDetails = todo.action_details;
    const todoableType = todo.todoable_type;
    const todoableId = todo.todoable_id;
    return { createdAt, actionDetails, todoableType, todoableId, ...todo };
  });

export const getPath = todo => {
  const { todoableId, todoable } = todo;
  switch (todo.category) {
    case "approve_booking":
    case "accept_booking":
    case "submit_candidates":
      return `/jobs/${todoableId}/details`;
    case "create_user":
      return `/settings/users`;
    case "complete_profile":
    case "additional_profile_information":
      return `/settings/profile`;
    case "offer_request_reference":
    case "offer_submit_additional_references":
    case "offer_approved":
      return `/offers/${todoableId}`;
    case "user_application":
      return `/jobs/${get(
        todoable,
        "booking_id"
      )}/candidates?applicationId=${todoableId}`;
    case "message_reply":
      return `/conversations/${todoableId}`;
    case "interview_confirm":
      return `/interviews/${todoableId}`;
    case "interview_submit_feedback":
      return `/interviews/${todoableId}?shouldSubmitFeedBack=true`;
    case "interview_rescheduled":
      return `/interviews/${todoableId}?shouldRescheduleInterview=true`;
    case "interview_self_schedule":
      return `/self-schedule?interview_format_id=${todoableId}`;
    default:
      return "/dashboard";
  }
};
